// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"712ee429","453":"97f7e7cd"}[chunkId] + ".chunk.js";
};